import { Checkbox, FormControlLabel, Stack } from '@mui/material';
import { Controller, Control, FieldError, FieldValues, Path } from 'react-hook-form';
import ErrorFormInput from '../error';

interface CheckboxFormInputProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  label?: string;
  error?: FieldError;
}

export default function CheckboxFormInput<T extends FieldValues>({
  control,
  name,
  label,
  error
}: CheckboxFormInputProps<T>) {
  return (
    <Stack>
      <Controller
        control={control}
        name={name}
        defaultValue={false as any}
        render={({ field }) => (
          <FormControlLabel
            control={<Checkbox {...field} onChange={(e) => field.onChange(e.target.checked)} />}
            label={label?.length ? label : ''}
            checked={field.value}
          />
        )}
      />
      {error && <ErrorFormInput error={error} />}
    </Stack>
  );
}
